/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'attach': {
    width: 24,
    height: 24,
    viewBox: '0 0 24 24',
    data: '<path pid="0" d="M8 17.328V7.5A4.5 4.5 0 0112.5 3v0A4.5 4.5 0 0117 7.5v11a3 3 0 01-3 3v0a3 3 0 01-3-3V9.041a1.5 1.5 0 011.5-1.5v0a1.5 1.5 0 011.5 1.5V17" _stroke="#4F4F4F"/>'
  }
})
